(ns ycweb.app.admin.storeplans.common
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as yuc]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defn calculate-turn [sales quantity days]
  (when (and sales (not (zero? sales)) quantity (not (zero? quantity)))
    (yuc/round (/ (/ (* sales 365) (if (pos? days) days 14)) quantity))))

(defn calculate-qty [sales turn days]
  (when (and sales (not= sales 0) turn (not= turn 0))
    (yuc/round (/ (* sales 365) (* days turn)))))

(defn calculate-need [paid-for on-order stock non-picking-stock]
  (let [difference (- stock non-picking-stock)
        greatest-diff (if (neg? difference) 0 difference)
        need (max 0 (- paid-for on-order greatest-diff))]
    need))

(defn multiply-fields [val-1 val-2]
  ((fnil * 0 0) val-1 val-2))

(defn skip-not-ranged? [override-type mdq in-store-stock-qty total-qty]
  (and
    (or (= override-type :global) (= override-type :override))
    (or
      (or (not (yuc/presence total-qty)) (zero? total-qty))
      (+ (or total-qty 0) (or mdq 0) (or in-store-stock-qty 0)))))

(defn total-qty-cond [override-type {:keys [mdq total-qty in-store-stock-qty o-mdq o-total-qty]}]
  (let [override? (yuc/presence o-total-qty)
        current-mdq (or o-mdq mdq 0)
        current-total-qty (or o-total-qty total-qty 0)

        error?
        (<
          current-total-qty
          current-mdq)

        no-change?
        (=
          total-qty
          o-total-qty)

        de-ranged?
        (and
          total-qty
          (pos? total-qty)
          override?
          (zero? o-total-qty))

        newly-ranged?
        (and
          override?
          (pos? o-total-qty)
          (or
            (nil? total-qty)
            (zero? total-qty)))

        feedback-skip-not-ranged?
        (and newly-ranged? (= override-type :global))

        #_(skip-not-ranged? override-type mdq in-store-stock-qty total-qty)]

    {:saveable-value
     (cond
       feedback-skip-not-ranged?
       total-qty

       :else
       o-total-qty)

     :feedback
     (cond
       feedback-skip-not-ranged?
       "Skipped, not ranged"

       error?
       "Error"

       (and override? de-ranged?)
       "De-Ranged"

       (and override? newly-ranged?)
       "Newly Ranged"

       (and override? no-change?)
       nil

       override?
       "Changed"

       :else nil)

     :class
     (cond
       no-change?
       [:cell-group-colour]

       feedback-skip-not-ranged?
       (yuc/bem :cell-status [:purple])

       error?
       (yuc/bem :cell-status [:error])

       (and override? de-ranged?)
       (yuc/bem :cell-status [:dark-grey])

       (and override? newly-ranged?)
       (yuc/bem :cell-status [:success])

       override?
       (yuc/bem :cell-status [:info])

       :else
       [:cell-group-colour])}))

(defn in-store-stock-qty-cond [override-type {:keys [mdq in-store-stock-qty total-qty o-mdq o-in-store-stock-qty]} ]
  (let [override? (yuc/presence o-in-store-stock-qty)
        current-mdq (or o-mdq mdq)

        error?
        (<
          (or o-in-store-stock-qty in-store-stock-qty 0)
          (or current-mdq 0))

        no-change?
        (=
          in-store-stock-qty
          (or o-in-store-stock-qty 0))

        feedback-skip-not-ranged?
        (skip-not-ranged? override-type mdq in-store-stock-qty total-qty)]

    {#_#_:saveable-value
     (cond
       feedback-skip-not-ranged?
       in-store-stock-qty

       :else
       o-in-store-stock-qty)

     :feedback
     (cond
       (and override? no-change?)
       nil

       error?
       "Error"

       override?
       "Changed"

       feedback-skip-not-ranged?
       "Skipped, not ranged"

       :else nil)

     :class
     (cond
       (and override? no-change?)
       [:cell-group-colour]

       error?
       (yuc/bem :cell-status [:error])

       override?
       (yuc/bem :cell-status [:info])

       feedback-skip-not-ranged?
       (yuc/bem :cell-status [:purple])

       :else
       [:cell-group-colour])}))

(defn mdq-cond [override-type {:keys [mdq in-store-stock-qty total-qty o-mdq o-in-store-stock-qty o-total-qty]}]
  (let [override? (yuc/presence o-mdq)

        no-change? (= o-mdq mdq)

        current-mdq (or o-mdq mdq)

        current-total-qty (or o-total-qty total-qty 0)

        warning?
        (and
          (zero? current-mdq)
          (pos? current-total-qty))

        feedback-skip-not-ranged?
        (skip-not-ranged? override-type mdq in-store-stock-qty total-qty)]

    {#_#_:saveable-value
     (cond
       feedback-skip-not-ranged?
       mdq

       :else
       o-mdq)

     :feedback
     (cond
      #_#_ feedback-skip-not-ranged?
       "Skipped, not ranged"

       (and override? no-change?)
       nil

       warning?
       "Warning"

       override?
       "Changed"

       #_#_feedback-skip-not-ranged?
       (yuc/bem :cell-status [:purple])

       :else nil)
     :class
     (cond
       (and override? no-change?)
       [:cell-group-colour]

       warning?
       (yuc/bem :cell-status [:warning])

       override?
       (yuc/bem :cell-status [:info])

       :else
       [:cell-group-colour])}))

(defn determine-feedback [focus-key override-type mdq total-qty in-store-stock-qty o-mdq o-total-qty o-in-store-stock-qty]
  (let [changes-payload
        {:mdq mdq
         :in-store-stock-qty in-store-stock-qty
         :total-qty total-qty
         :o-mdq o-mdq
         :o-in-store-stock-qty o-in-store-stock-qty
         :o-total-qty o-total-qty}]
    (case focus-key
      :total-qty (total-qty-cond override-type changes-payload)
      :in-store-stock-qty (in-store-stock-qty-cond override-type changes-payload)
      :mdq (mdq-cond override-type changes-payload))))

(defn transform-store-plan-item
  [{:keys [store-plan-id vid companyname brandrootid brandrootname code features end_use catfullname contentlive supplier_id
           notavailable dateexpected paidfor onorder stock nonpickingstock minqtyfordisplay instock_qty category_id
           qty costprice freestock futureorder supplieronhand price brandtype store-id ringfenced-qty
           width height length contentid store-plan-store-name] :as store-plan-item}
   now days avg-on-hand sales ibt-in-transit ibt-pending store]
  (let [eta
        (when
          (and
            (= notavailable 1)
            dateexpected
            (not (zero? dateexpected))
            (dt/after? (ud/from-php-date dateexpected) (dt/now)))
          (ud/date-format (ud/from-php-date dateexpected) "YYYY-MM-dd"))

        notavailable
        (cond
          (= notavailable 2)
          "Discontinued"

          (= notavailable 1)
          "No"

          :else
          "Yes")

        needed-at-hq
        (calculate-need paidfor onorder stock nonpickingstock)]

    {:store-plan/id store-plan-id
     :company/name companyname
     :brand/root-name brandrootname
     :store-plan/days days
     :store/id store-id
     :variation/id vid
     :supplier/id supplier_id
     :brand/root-id brandrootid
     :product/name (:name store-plan-item)
     :product/id contentid
     :variation/code code
     :variation/features features
     :variation/end-use end_use
     :category/id category_id
     :product/status contentlive
     :supplier/availability notavailable
     :supplier/estimated-arrival-time eta
     :store-plan/mdq minqtyfordisplay
     :store-plan/in-store-stock-qty instock_qty
     :store-plan/total-qty qty
     :store-plan/display-qty (- qty minqtyfordisplay)
     :variation/cost-price costprice
     :variation/price price
     :store-plan-variation/sub-total (multiply-fields costprice qty)
     :store-plan-variation/retail-value (multiply-fields price qty)
     :stock/on-hand (or (:qty store) 0)
     :stock/transit-ibt (:qty ibt-in-transit)
     :stock/store-ibt (:qty ibt-pending)
     :store/on-hand-history-avg (or (:qty_avg avg-on-hand) 0)
     :variation/free-stock freestock
     :variation/ringfenced-qty ringfenced-qty
     :variation/on-order onorder
     :variation/future-order futureorder
     :variation/supplier-on-hand supplieronhand
     :variation/non-picking-stock nonpickingstock
     :store/sales (:units sales)
     :stock/qty-on-hand
     (-
       (or instock_qty 0)
       (or (:qty store) 0)
       (or (:qty ibt-in-transit) 0)
       (or (:qty ibt-pending) 0))
     :store/stock-turn (calculate-turn (:units sales) qty days)
     :store/stock-turn-avg (calculate-turn (:units sales) (:qty_avg avg-on-hand) days)
     :store/total-qty-stock-turn (calculate-turn (:units sales) qty days)
     :store/in-store-stock-turn (calculate-turn (:units sales) instock_qty days)
     :stock/needed-at-hq needed-at-hq
     :store/cost-price-sales (multiply-fields (:units sales) costprice)
     :variation/brand-type brandtype
     :variation/width width
     :variation/height height
     :variation/length length}))

(defn build-variation-stats [variations]
  (reduce
    (fn [acc variation]
      (let [pos-qty? (> (:store-plan/total-qty variation) 0)
            is-es? (= (:company/name variation) "Edison Stone (Pty) Ltd")
            shared-brand? (not= (:variation/brand-type variation) "Shared")
            on-hand? (> (:stock/on-hand variation) 0)]
        (->
          acc
          (update :stats/cost-price-sales #(+ (if (nil? %) 0 %) (:store/cost-price-sales variation)))
          (update :stats/skus (if pos-qty? (fnil inc 0) identity))
          (update :stats/qty
            #(if pos-qty?
               (+ (if (nil? %) 0 %)
                 (:store-plan/total-qty variation))
               %))
          (update :stats/cost-price-value
            #(if pos-qty?
               (+ (if
                    (nil? %) 0 %)
                 (:store-plan-variation/sub-total variation))
               %))
          (update :stats/retail-price-value
            #(if pos-qty?
               (+ (if (nil? %) 0 %)
                 (:store-plan-variation/retail-value variation))
               %))
          (update :stats/face-needed
            #(if pos-qty?
               (+ (if (nil? %) 0 %)
                 (/
                   (*
                     (:variation/width variation)
                     (:variation/length variation))
                   (* 100 100)))
               %))
          (update :stats/volume-needed
            #(if pos-qty?
               (+ (if (nil? %) 0 %)
                 (/
                   (*
                     (:store-plan/total-qty variation)
                     (:variation/width variation)
                     (:variation/length variation)
                     (:variation/height variation))
                   (* 100 100 100)))
               %))
          (update-in [:stats/es-plan :skus] (if (and pos-qty? is-es?) (fnil inc 0) identity))
          (update-in [:stats/es-plan :qty]
            #(if (and pos-qty? is-es?)
               (+ (if (nil? %) 0 %)
                 (:store-plan/total-qty variation))
               %))
          (update-in [:stats/es-plan :cost-price-value]
            #(if (and pos-qty? is-es?)
               (+ (if (nil? %) 0 %)
                 (:store-plan-variation/sub-total variation))
               %))
          (update-in [:stats/non-shared-plan :skus]
            (if (and pos-qty? shared-brand?) (fnil inc 0) identity))
          (update-in [:stats/non-shared-plan :cost-price-value]
            #(if (and pos-qty? shared-brand?)
               (+ (if (nil? %) 0 %) (:store-plan-variation/sub-total variation))
               %))
          (update :stats/current-skus (if on-hand? (fnil inc 0) identity))
          (update :stats/current-qty
            #(if on-hand?
               (+ (if (nil? %) 0 %) (:stock/on-hand variation))
               %))
          (update :stats/current-cost-price-value
            #(if on-hand?
               (+ (if (nil? %) 0 %) (* (:stock/on-hand variation) (:variation/cost-price variation)))
               %))
          (update :stats/current-retail-price-value
            #(if on-hand?
               (+ (if (nil? %) 0 %) (* (:stock/on-hand variation) (:variation/price variation)))
               %))
          (update-in [:stats/es-current :skus]
            (if (and on-hand? is-es?) (fnil inc 0) identity))
          (update-in [:stats/es-current :qty]
            #(if (and on-hand? is-es?)
               (+ (if (nil? %) 0 %) (:stock/on-hand variation))
               %))
          (update-in [:stats/es-current :cost-price-value]
            #(if (and on-hand? is-es?)
               (+ (if (nil? %) 0 %)
                 (* (:stock/on-hand variation) (:variation/cost-price variation)))
               %))
          (update-in [:stats/non-shared-current :skus]
            (if (and on-hand? shared-brand?)
              (fnil inc 0) identity))
          (update-in [:stats/non-shared-current :cost-price-value]
            #(if (and on-hand? shared-brand?)
               (+ (if (nil? %) 0 %) (* (:stock/on-hand variation) (:variation/cost-price variation)))
               %)))))
    {}
    variations))

(rum/defc suggested-filter-item < rum/reactive [app-atom selected-atom item-text item-subtext config]
  (let [selected-text (rum/react selected-atom)
        selected? (= item-text selected-text)]
    [:li
     {:on-click #(reset! selected-atom item-text)}
     [:a.text-link
      (merge
        (urlstate/href-on-click
          #(grid/dispatch-action app-atom :store-plan/apply-filter config)))
      [:span
       {:style {:font-weight (if selected? "bold" "normal")}}
       item-text
       [:span
        {:class :u-text-aluminium}
        (str " " item-subtext)]]]]))

(defmethod grid/action :store-plan/apply-filter [app-atom {:keys [sort-on filter-on datatable-key] :as config} _]
  (grid/close-modal app-atom)
  (let [table-atom (datatables/table-cursor app-atom datatable-key)]
    (swap! table-atom update-in [:config :options]
      (fn [options]
        (assoc options
          :filters filter-on
          :sort-title (:column-title sort-on)
          :order (:order sort-on))))))

(defn update-overview-rows [app-atom atom-path rows row-id]
  (swap! app-atom update-in atom-path
    (fn [items]
      (reduce
        (fn [acc row]
          (let [current-id (get row row-id)
                current-row (get acc current-id)]
            (->
              acc
              (assoc
                current-id
                (yuc/maybe assoc current-row
                  :editing? false
                  :override/mdq (:override/mdq row)
                  :override/in-store-stock-qty (:override/in-store-stock-qty row)
                  :override/total-qty (:override/total-qty row)
                  :override/in-store-stock-turn (:override/in-store-stock-turn row)
                  :override/store-plan-turn (:override/store-plan-turn row)))

              (update-in [current-id :store-plan/stores]
                (fn [stores-idx]
                  (reduce
                    (fn [acc current-store]
                      (->
                        acc
                        (update (:store/id current-store)
                          (fn [store]
                            (yuc/maybe assoc
                              store
                              ;;Store MDQ
                              :override/mdq (:override/mdq current-store)
                              ;;Store in stock quantity
                              :override/in-store-stock-qty (:override/in-store-stock-qty current-store)
                              ;;Store plan total quantity
                              :override/total-qty (:override/total-qty current-store)

                              :override/feedback (:override/feedback current-store)

                              :override-type/mdq (:override-type/mdq current-store)
                              :override-type/in-store-stock-qty (:override-type/in-store-stock-qty current-store)
                              :override-type/total-qty (:override-type/total-qty current-store)
                              :override-type/in-store-stock-turn (:override-type/in-store-stock-turn current-store)
                              :override-type/store-plan-turn (:override-type/store-plan-turn current-store)
                              :override-type/in-store-stock-max (:override-type/in-store-stock-turn current-store)
                              :override-type/store-plan-max (:override-type/store-plan-turn current-store))))))
                    stores-idx (:stores row)))))))
        items rows))))

(defn sum-rows [sum-key rows]
  (reduce
    #((fnil + 0 0) %1 %2)
    0 (map sum-key rows)))

(defn row-average [sum-key divide-by rows]
  (when (and divide-by (pos? divide-by))
    (/ (sum-rows sum-key rows) divide-by)))